import React from "react";

export default function AboutPage() {
  return (
    <div
      className="about-container"
      style={{
        paddingTop: "2rem" // ✅ Add space at the top
      }}
    >
      <div
        style={{
          whiteSpace: "pre-wrap",
          paddingLeft: "2rem",
          paddingRight: "2rem",
          maxWidth: "900px",
          margin: "0 auto"
        }}
      >
{`We live in amazing times.

Today we stream 4k video with multi-channel, high definition audio directly to our TVs, PCs, tablets and phones.  Just about every movie ever filmed, every song ever recorded and every book ever published can be downloaded and enjoyed with a few taps on a touchscreen.

It wasn't always like this.

Back in the late '80's and early '90's, you'd have to go to an "EggHead Software", a "CompUSA" or some other brick-&-mortar software distributor to buy games and other software.  Installing software could be a significant time investment and often consisted of taking a pile of floppy disks and swapping through disk-after-disk to finish installing a larger program of say, ~15MB in size.

Homes were connected to the nascent Internet by 14.4kbps modems or POTS telephone lines that were barely able to handle lightweight, text-based, UseNet group chat forums and any files distributed via that network were generally tiny "midi" files and crude, pixelated images.  Email was often a stand-alone application.  Instant messaging was still a gleam in ICQ's eye.

Into this exciting, yet clunky era of software/internet evolution stepped AOL.  They were the first, mass direct-to-home software distributor and boy did they distribute.  It started with 5-1/4" floppy disks, then transitioned to 3.5" floppies and finally moved to CD-ROMs before technological and market advances sidelined their business model.

During this time I started collecting AOL and their competitors' ISP disks not because I liked their services - but because they were a source of free floppy disk storage.  Just about every week or so their disks would arrive in the mail and you could simply wipe the floppy and copy what you desired onto them.  At one point I had to move my residence and I found I had a heavy box full of AOL, Compuserve, Earthlink and other disks still in their packaging and instead of trashing them like most other folks did, I stopped and began looking through them.  It was at that point that I found the artwork and various marketing schemes rather fascinating.  I began anticipating what the next mailer was going to look like, what sort of packaging would they opt to deliver, what sort of artwork would be employed... It all rather tickled my OCD and so I began collecting these disks in earnest.

The disks just kept coming in the mail, so I just kept tossing them into boxes.  When I was in a store or a bank or a post office, the "Have One - It's FREE!" disks were just sitting there on the counter, ripe for the taking.  Eventually I had over two thousand ISP disks, most of them from AOL.  Eventually software distribution transitioned from hard-media to ever increasing bandwidth distro via ISDN, DSL, cable- and fiber modems, so eventually the halcyon days of AOL disks maxing-out our landfills was finally over...

...But I still had my disks and I kept collecting them by bothering family, friends and colleagues to see if they had some rare gem hiding in their junk drawers or an old filing cabinet.

So what does one do with over 2000 AOL disks?  Easy (or maybe not so easy) - One builds a website to show 'em off!

Enjoy the Bounty everyone!

; D

P.S.,  At some point I'll also be adding links to all my other ISP disks to this site, but I gotta take pictures first - and that is a very time-consuming proposition.  Someday though...
`}
      </div>
    </div>
  );
}
